import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import TermsModal from '../../components/TermsModal/TermsModal';
import PrivacyModal from '../../components/PrivacyModal/PrivacyModal';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Credenciales incorrectas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__logo">
          <img src={process.env.PUBLIC_URL + '/cash_logo_color-06.png'} alt="Cash Sol SAC" />
        </div>
        <h2>Iniciar sesión</h2>
        <p className="auth-card__sub">Ingresa con tu DNI o correo electrónico</p>

        {error && <div className="auth-alert auth-alert--error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label>DNI o Correo electrónico</label>
            <div className="auth-input-wrap">
              <i className="fa-solid fa-user"></i>
              <input
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="12345678 o correo@email.com"
                required
              />
            </div>
          </div>

          <div className="auth-field">
            <label>Contraseña</label>
            <div className="auth-input-wrap">
              <i className="fa-solid fa-lock"></i>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <div className="auth-form__footer">
            <Link to="/recuperar-password" className="auth-link">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>

          <button type="submit" className="btn-primary auth-btn" disabled={loading}>
            {loading ? <span className="spinner-sm"></span> : 'Ingresar'}
          </button>
        </form>

        <p className="auth-card__bottom">
          ¿No tienes cuenta?{' '}
          <Link to="/register" className="auth-link">
            Regístrate aquí
          </Link>
        </p>
        <p className="auth-card__terms-btn-wrap">
          <button type="button" onClick={() => setIsTermsOpen(true)} className="auth-terms-btn">
            Términos y condiciones clientes uso del portal
          </button>
        </p>
        <p className="auth-card__terms-btn-wrap">
          <button type="button" onClick={() => setIsPrivacyOpen(true)} className="auth-terms-btn">
            Política de privacidad y protección de datos personales
          </button>
        </p>
        <p className="auth-card__back">
          <Link to="/" className="auth-link">
            <i className="fa-solid fa-arrow-left"></i> Volver al inicio
          </Link>
        </p>
      </div>
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
    </div>
  );
};

export default Login;
